import PersonIcon from '@material-ui/icons/Person';
import { UserCreateView, UserEditView } from './views';

export default {
  create: UserCreateView,
  edit: UserEditView,
  icon: PersonIcon,
};
